module.exports = __webpack_public_path__ + "static/media/default-artwork.6bba9800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default-artwork.png
// module id = 118
// module chunks = 0